export default {
  SET_REWARDS(state, data) { state.rewards = data; },
};
